import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
// import IconButton from "@material-ui/core/IconButton";
// import Snackbar from "@material-ui/core/Snackbar";
// import Button from "@material-ui/core/Button";
import times from "../../assets/times.svg";
import tick from "../../assets/confirmTb.svg";
import { Form } from "react-bootstrap";
// import {groupings} from '../BalanceSheet/mockGrouping'
import swal from "sweetalert";
import { motion } from "framer-motion";

// import CloseIcon from "@material-ui/icons/Close";

import { batchUpdateConventionalMode } from "../../redux/actions/TemplateTabs/actionCM";

import commoncss from "../../myfin_v2/css/common.module.css";
import dropdowncss from "../../myfin_v2/css/dropdown.module.css";
import { ReactComponent as DownIcon } from "../../myfin_v2/assets/icons/down_arrow.svg";
import { ReactComponent as UpIcon } from "../../myfin_v2/assets/icons/up_arrow.svg";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CircleCheckIcon } from "../../myfin_v2/assets/icons/circle_check.svg";
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/plusprimary.svg";


const card = {
  position: "fixed",
  bottom: "3%",
  right: "2%",
  width: "300px",
  // height:'55px',
  backgroundColor: "white",
  zIndex: "99",
  borderRadius: "2px",
  boxShadow: "5px 5px 15px rgba(0, 0, 0, 0.3)",
  // boxShadow: '5px 10px #888888'
};
const action = {
  borderRadius: "2px",
  height: "50px",
  backgroundColor: "var(--clr-bg)",
  zIndex: "99",
  display: "flex",
  alignItems: "center",
};
const form = {
  borderRadius: "2px",
  height: "170px",
  backgroundColor: "white",
  zIndex: "99",
};

const CustomSelect = ({ value, onChange, placeholder, options, disabled, valueKey, labelKey }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const dropdownRef = React.useRef(null);
  const inputRef = React.useRef(null);

  // Sync input value with selection
  useEffect(() => {
    if (!value) {
      setInputValue("");
    } else {
      const found = options?.find(opt => {
        const val = valueKey === "json" ? JSON.stringify(opt) : (valueKey ? opt[valueKey] : opt);
        return String(val) === String(value);
      });
      if (found) {
        setInputValue(labelKey ? found[labelKey] : found);
      } else {
        try {
          if (typeof value === "string" && value.startsWith("{")) {
            const parsed = JSON.parse(value);
            if (labelKey && parsed[labelKey]) {
              setInputValue(parsed[labelKey]);
              return;
            }
          }
        } catch (e) {}
        setInputValue(value);
      }
    }
  }, [value, options, labelKey, valueKey]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        // Revert input text back to the selected label if search was left unfinished
        if (!value) {
          setInputValue("");
        } else {
          const found = options?.find(opt => {
            const val = valueKey === "json" ? JSON.stringify(opt) : (valueKey ? opt[valueKey] : opt);
            return String(val) === String(value);
          });
          if (found) {
            setInputValue(labelKey ? found[labelKey] : found);
          } else {
            try {
              if (typeof value === "string" && value.startsWith("{")) {
                const parsed = JSON.parse(value);
                if (labelKey && parsed[labelKey]) {
                  setInputValue(parsed[labelKey]);
                  return;
                }
              }
            } catch (e) {}
            setInputValue(value);
          }
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [value, options, labelKey, valueKey]);

  const handleSelect = (option) => {
    if (disabled) return;
    const val = valueKey === "json" ? JSON.stringify(option) : (valueKey ? option[valueKey] : option);
    onChange({ target: { value: val } });
    setIsOpen(false);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setIsOpen(true);
  };

  const handleFocus = () => {
    setIsOpen(true);
  };

  // Filter options based on input value
  const filteredOptions = useMemo(() => {
    if (!options) return [];
    if (!inputValue) return options;
    
    // If the input value matches the currently selected option, do not filter (or filter if they type more)
    const foundLabel = options.find(opt => {
      const val = valueKey === "json" ? JSON.stringify(opt) : (valueKey ? opt[valueKey] : opt);
      return String(val) === String(value);
    });
    const selectedStr = foundLabel ? (labelKey ? foundLabel[labelKey] : foundLabel) : "";
    if (inputValue === selectedStr) return options;

    return options.filter(opt => {
      const label = labelKey ? opt[labelKey] : opt;
      return String(label || "").toLowerCase().includes(inputValue.toLowerCase());
    });
  }, [options, inputValue, labelKey, valueKey, value]);

  const hasValue = !!value;

  return (
    <div 
      ref={dropdownRef} 
      className={`${dropdowncss.customSelectWrapper} ${disabled ? dropdowncss.disabledSelect : ""}`}
    >
      <div 
        className={`${dropdowncss.customSelectTrigger} ${!hasValue ? dropdowncss.customSelectPlaceholder : ""}`}
        onClick={() => !disabled && setIsOpen(true)}
      >
        <input
          ref={inputRef}
          type="text"
          placeholder={placeholder}
          value={inputValue}
          onChange={handleInputChange}
          onFocus={handleFocus}
          disabled={disabled}
          style={{
            border: "none",
            outline: "none",
            background: "transparent",
            width: "100%",
            fontSize: "12.5px",
            color: "#111111",
            padding: 0,
          }}
        />
        <span className={dropdowncss.customSelectArrow}>
          {isOpen ? <UpIcon width={10} height={6} style={{ color: "#2D8861" }} /> : <DownIcon width={10} height={6} style={{ color: "#2D8861" }} />}
        </span>
      </div>
      {isOpen && (
        <div className={dropdowncss.customSelectOptionsContainer}>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((opt, idx) => {
              const val = valueKey === "json" ? JSON.stringify(opt) : (valueKey ? opt[valueKey] : opt);
              const label = labelKey ? opt[labelKey] : opt;
              const isSelected = String(val) === String(value);

              return (
                <div 
                  key={idx}
                  className={`${dropdowncss.customSelectOption} ${isSelected ? dropdowncss.active : ""}`}
                  onClick={() => handleSelect(opt)}
                >
                  {label}
                </div>
              );
            })
          ) : (
            <div style={{ padding: "8px 10px", fontSize: "12.5px", color: "#b3c0bd", textAlign: "center" }}>
              No options found
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const MultiSelect = (props) => {
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem('user'));
  const { multiSelectedRows } = useSelector((state) => state.selectedDragReducer);
  const multiSelectedRows_ = useMemo(() => multiSelectedRows, [multiSelectedRows])
  const TB_ID = useSelector((initialState) => initialState.reducer.tb_id);
  const groupData = useSelector((state) => state.TTGroupingReducer);
  const [open, setOpen] = React.useState(false);
  const [menu, setMenu] = React.useState(false);
  // const [groupings, setGroupings] = useState(group);
  const [selectedFs, setSelectFs] = useState("");
  const [selectedNoteGroup, setSelectNoteGroup] = useState("");
  const [selectedSubGroup, setSelectSubGroup] = useState("");
  const conventionModeData = useSelector(
    (state) => state.ConventionModeReducer
  );


  const isProgrammatic = React.useRef(false);

  const handleClose = () => {
    setOpen(false);
    setMenu(false);
  };

  useEffect(() => {
    if (multiSelectedRows_.length > 0) {
      setOpen(true);
      if (multiSelectedRows_.length === 1) {
        const singleRow = multiSelectedRows_[0];
        const fsGrp = singleRow?.map_data?.cy_map?.fs_grp || singleRow?.fs_grp || "";
        const noteGrp = singleRow?.map_data?.cy_map?.note_grp || singleRow?.note_grp || "";
        const noteNo = singleRow?.map_data?.cy_map?.note_no || singleRow?.note_no || "";
        const subGrp = singleRow?.map_data?.cy_map?.sub_grp || singleRow?.sub_grp || "";

        isProgrammatic.current = true;
        setSelectFs(fsGrp);
        setSelectNoteGroup(noteGrp ? JSON.stringify({ notes_grp: noteGrp, notes_no: noteNo }) : "");
        setSelectSubGroup(subGrp);
        setMenu(true);
        setTimeout(() => {
          isProgrammatic.current = false;
        }, 50);
      } else {
        setSelectFs("");
        setSelectNoteGroup("");
        setSelectSubGroup("");
      }
    } else {
      setOpen(false);
      setMenu(false);
      setSelectFs("");
      setSelectNoteGroup("");
      setSelectSubGroup("");
    }
  }, [multiSelectedRows_]);

  useEffect(() => {
    if (!isProgrammatic.current) {
      setSelectNoteGroup("");
      setSelectSubGroup("");
    }
  }, [selectedFs]);

  useEffect(() => {
    if (!isProgrammatic.current) {
      setSelectSubGroup("");
    }
  }, [selectedNoteGroup]);

  const handlePost = () => {
    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal("warning", "You don't have access", "warning");
      return;
    } else {
      swal({
        title: "Are you sure?",
        text: "clicking on ok, will change the the groupings of the selected rows",
        icon: "warning",
        buttons: true,
        dangerMode: false,
      }).then((willDelete) => {
        if (willDelete) {
          const { notes_grp, notes_no } = selectedNoteGroup ? JSON.parse(selectedNoteGroup) : { notes_grp: '', notes_no: '' };
          const updatedData = multiSelectedRows_.map((data) => {
            const mapData = {
              fs_grp: selectedFs,
              note_grp: notes_grp,
              note_no: notes_no,
              sub_grp: selectedSubGroup
            };
            return {
              ...data,
              fs_grp: selectedFs,
              note_grp: notes_grp,
              note_no: notes_no,
              sub_grp: selectedSubGroup,
              map_data: {
                cy_map: { ...mapData },
                py_map: { ...mapData }
              }
            }
          })
          dispatch(batchUpdateConventionalMode(conventionModeData.set_payload, updatedData))
          swal("Groupings have been added to the selected rows!", {
            icon: "success",
          });
        } else {
          swal("Ledger not deleted!");
        }
      });
    }
  }

  function handleAddOptions() {
    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal("warning", "You don't have access", "warning");
      return false;
    }
    if ((selectedFs === "") | (selectedNoteGroup === "")) {
      return swal("Please select the Fs and Notes groupings", "", "warning");
    }

    props.setAddGrouping(true);
    const newSg = {};
    newSg.fs_grp = selectedFs;
    newSg.note_grp = selectedNoteGroup;
    props.SetNewSg(newSg);
    setMenu(false);
  }

  const handleGroupData = (type) => {
    const groupDataRes = groupData.response ?? [];
    switch (type) {
      case "fs_grp":
        if (groupData.isSuccess) {
          return groupDataRes?.fs_grp?.map(fsGrp => fsGrp.fs_grp)
        } else {
          return []
        }
      case "note_grp":
        if (groupData.isSuccess && selectedFs) {
          return groupDataRes?.fs_grp?.find(fsGrp => fsGrp.fs_grp === selectedFs)
            .notes_grp.map(notes => { return { notes_grp: notes.notes_grp, notes_no: notes.notes_no } })
        } else {
          return []
        }
      case "sub_grp":
        if (groupData.isSuccess && selectedFs && selectedNoteGroup) {
          return groupDataRes?.fs_grp?.find(fsGrp => fsGrp.fs_grp === selectedFs)
            ?.notes_grp.find(note => note.notes_grp === JSON.parse(selectedNoteGroup).notes_grp)?.sub_grp.map(subGrp => subGrp.sub_grp)
        } else {
          return []
        }
      default:
        return []
    }
  }

  return (
    <>
      {open && (
        <div className={dropdowncss.multiDropdownDiv}>
          <div className={dropdowncss.multiDropdownHead}>
            <span>
              Multi select Menu
            </span>
            <span className={commoncss.dFlex} style={{ "gap": "10px" }}>
              {selectedFs !== "" || selectedNoteGroup !== "" || selectedSubGroup !== "" ? (
                <CircleCheckIcon 
                  className={commoncss.clickable} 
                  style={{ cursor: "pointer" }}
                  onClick={handlePost} 
                />
              ) : null}
              {menu ? <DownIcon className={commoncss.clickable}
                onClick={() => {
                  setMenu(!menu)
                }} /> : <UpIcon className={commoncss.clickable}
                  onClick={() => {
                    setMenu(!menu)
                  }} />}
              <CloseIcon width={18} height={18} className={commoncss.clickable}
                onClick={() => {
                  handleClose();
                }} />
            </span>

          </div>
          {menu && (
            <motion.div
              className={dropdowncss.multiSelectBody}
              // initial={{y:'-1vh'}}
              // animate={{y:0}}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              <CustomSelect
                value={selectedFs}
                onChange={(e) => setSelectFs(e.target.value)}
                placeholder="Select Fs grouping"
                options={handleGroupData('fs_grp')}
              />

              <CustomSelect
                value={selectedNoteGroup}
                onChange={(e) => setSelectNoteGroup(e.target.value)}
                placeholder="Select Notes grouping"
                options={handleGroupData('note_grp')}
                disabled={!selectedFs}
                valueKey="json"
                labelKey="notes_grp"
              />

              <CustomSelect
                value={selectedSubGroup}
                onChange={(e) => setSelectSubGroup(e.target.value)}
                placeholder="Select Sub grouping"
                options={handleGroupData('sub_grp')}
                disabled={!selectedNoteGroup}
              />
              <div
                className={`${commoncss.clickable} ${commoncss.dFlex} ${commoncss.fs14}`} style={{ "place-self": "center", "color": "#2D8861" }}
                onClick={() => {
                  handleAddOptions();
                }}
              >
                <PlusIcon />&nbsp;Add Options
              </div>
            </motion.div>
          )}
        </div>
      )}
    </>
  );
};

export default MultiSelect;
